import React from 'react';
import { makeStyles } from '@material-ui/core';
import { FormikTextField } from 'formik-material-fields';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import InputAdornment from '@material-ui/core/InputAdornment';
import { useTranslation } from 'react-i18next';

export default function RawMaterialsTable(props) {
    const classes = useStyles();

    const { t } = useTranslation();

    const rows = props.productionOrder.bomIn.map(m => {

            return (
                createData( m.productReference, m.productId, m.uom))
        }
        )

    function createData( code, id, uom) {
        return {  code, id, uom };
    }

    return (
        <Table className={classes.table} aria-label="customized table">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.headCell}>{"Article"}</TableCell>
                    <TableCell className={classes.headCell}>{t("Amount to add")}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.name} className={classes.row}>
                        <TableCell className={classes.typeCell} width={"80%"}>{row.code}</TableCell>
                        <TableCell className={classes.quantityCell} width={"20%"}> 
                            <FormikTextField id="outlined-search" name={"quantity" + row.id} label="" type="number" variant="outlined" onChange={(e) => props.quantityChanged(e, row.id)} className={classes.quantityTextField} size="small" InputProps={{
                                endAdornment: <InputAdornment position="end">{row.uom.toLowerCase()}</InputAdornment>, inputProps: { min: "1", step: "1" },
                            }} />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )

}

const useStyles = makeStyles(() => ({
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },
    typeCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px",
    },   
    quantityCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        paddingRight: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
    },  
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"
    },   
    quantityTextField: {
        width: "100%"
    },
  
    
}));